import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionNeuroscience.mp4",
    poster: "/videos/solutionNeuroscience.jpg",
    heading: "Superior Optics for Revolutionary Neuroscience",
    subheading: "Where scientific innovation meets unparalleled clarity, setting the stage for transformative discoveries.",
    buttonLink: "/solutions"
  }
];

function SolutionCentralOffice() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Lenses',
  'Collimators & Probes',
  'Passive Optical Components'
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1" style={{ marginTop: 50}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/neuroscience1.jpg" alt="Neuroscience" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Quality lenses unlocking neural insights</h2>
          <p className="solution-section-1-description">In the demanding realm of neuroscience, cutting-edge research hinges on optical solutions that capture the faintest neural signals. As single-photon and two-photon microscopes monitor synaptic responses, the challenge is clear: only high-quality, precision-engineered lenses can reveal the intricate workings of the brain’s circuitry. Scientists require dependable optics that not only enhance image clarity but also withstand the rigors of in vivo experiments, driving the quest for affordable yet superior lens technology. And Go!Foton delivers!</p>
        </div>
      </div>

      <FactoidSection
        solution="neuroscience"
        title="Neuroscience trends: data-driven insights"
        description=""
      />

      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          <h2 className="solutions-section-checklist-heading">Engineered for neuroscience breakthroughs</h2>
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/solutions/neuroscience2.jpg" alt="Neuroscience" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <p className="solutions-section-checklist-description">At Go!Foton, our innovative GRIN lens solutions, are crafted to meet the escalating demands of neuroscience research. We specialize in lenses designed for both single photon and two photon microscopy, offering enhanced optical performance, rapid manufacturing speeds, and the flexibility to customize for your specific application, all at a low cost. Our commitment to driving scientific discovery is backed by proven value:</p>
          <ul className="solutions-section-checklist-points">
            <li>Speed of manufacturing  </li>
            <li>Customization </li>
            <li>Low cost</li>
            <li>One and two-photon lenses availability</li>
          </ul>
        </div>
      </div>


    <section className="solution-products-section">
      <h2>Advanced lenses for neuroscience</h2>
      <p className="solution-products-section-description">Discover the Go!Foton Advanced Lens Platform, specifically for Neuroscience application, featuring a breakthrough in optical engineering that delivers superior clarity, efficiency, and versatility for today’s research and discovery.</p>


<div className="products-grid">
  {topByFamily.map(({ family, topProduct }) => (
    <div key={family} className="product-card">
      {topProduct.image ? (
        <img
          src={topProduct.image}
          alt={family}
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: 215,
            backgroundColor: '#ddd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{family}</h3>
      <a
        href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}
        className="learn-more"
      >
        Learn More
      </a>
    </div>
  ))}
</div>

    </section>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionCentralOffice;
